import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const CardStack = () => {
  const wrapper = document.querySelector('.js-cards-wrapper');
  if (!wrapper) return;

  const cards = gsap.utils.toArray('.js-cards-card');
  const totalCards = cards.length;
  if (totalCards === 0) return;

  // ==============================
  // 調整パラメータ
  // ==============================
  const scrollMultiplier = 1.5; // スタックの距離（1カードあたりのスクロール量。大きいほどゆっくり）
  const overlapRatio = 0.15;   // フェード重なり具合（0〜0.5、大きいほど長くクロスフェード）

  wrapper.style.height = `${totalCards * 100 * scrollMultiplier}vh`;

  // 初期状態
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: index === 0 ? 1 : 0,
      zIndex: totalCards - index,
    });
  });

  // 全体の進行度(0〜1)でopacityを一括制御
  ScrollTrigger.create({
    trigger: wrapper,
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    onUpdate: (self) => {
      const progress = self.progress; // 0〜1
      const segmentSize = 1 / totalCards;

      cards.forEach((card, index) => {
        const segmentStart = index * segmentSize;
        const segmentEnd = (index + 1) * segmentSize;
        const overlap = segmentSize * overlapRatio;

        let opacity;

        if (index === 0) {
          // 最初のカード：フェードアウトのみ
          const fadeOutStart = segmentEnd - overlap;
          const fadeOutEnd = segmentEnd + overlap;

          if (progress <= fadeOutStart) {
            opacity = 1;
          } else if (progress >= fadeOutEnd) {
            opacity = 0;
          } else {
            opacity = 1 - (progress - fadeOutStart) / (fadeOutEnd - fadeOutStart);
          }
        } else if (index === totalCards - 1) {
          // 最後のカード：フェードインのみ
          const fadeInStart = segmentStart - overlap;
          const fadeInEnd = segmentStart + overlap;

          if (progress <= fadeInStart) {
            opacity = 0;
          } else if (progress >= fadeInEnd) {
            opacity = 1;
          } else {
            opacity = (progress - fadeInStart) / (fadeInEnd - fadeInStart);
          }
        } else {
          // 中間カード：フェードイン → フェードアウト
          const fadeInStart = segmentStart - overlap;
          const fadeInEnd = segmentStart + overlap;
          const fadeOutStart = segmentEnd - overlap;
          const fadeOutEnd = segmentEnd + overlap;

          if (progress <= fadeInStart) {
            opacity = 0;
          } else if (progress <= fadeInEnd) {
            opacity = (progress - fadeInStart) / (fadeInEnd - fadeInStart);
          } else if (progress <= fadeOutStart) {
            opacity = 1;
          } else if (progress <= fadeOutEnd) {
            opacity = 1 - (progress - fadeOutStart) / (fadeOutEnd - fadeOutStart);
          } else {
            opacity = 0;
          }
        }

        gsap.set(card, { opacity });
      });
    },
  });
};

export default CardStack;